export const DIRECTIONS = {
  DOWN: 'down',
  UP: 'up',
};
